import type { CartLineInput } from 'services/shopify';
import type { ShopifyProduct } from 'types/product/ShopifyProduct';

type BlockSellingPlan = Pick<CartLineInput, 'merchandiseId' | 'sellingPlanId'>;

export const getBlockSellingPlans = (
  shopifyProduct?: ShopifyProduct | null,
) => {
  if (!shopifyProduct) return null;

  const subscriptionItems =
    'subscriptions' in shopifyProduct
      ? shopifyProduct.subscriptions.map((sub) => ({
          merchandiseId: sub.id,
          sellingPlanId: sub.sellingPlan.id,
        }))
      : [];

  const variantItems = shopifyProduct.variants.map((variant) => ({
    merchandiseId: variant.id,
  }));

  return [...subscriptionItems, ...variantItems] as BlockSellingPlan[];
};
